webpackJsonp([1],Array(27).concat([
/* 27 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(138)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(164),
  /* scopeId */
  "data-v-7a5885be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var LOOP_OPTIONS = exports.LOOP_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": { "hls": { "withCredentials": false } },
            "html5": { "hls": { "withCredentials": false } },
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg"
        }
    }
};
var CHROMLESS_OPTIONS = exports.CHROMLESS_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": false,
            "flash": { "hls": { "withCredentials": false } },
            "html5": { "hls": { "withCredentials": false } },
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg"
        }
    }
};

var PLAYBACKRATES_OPTIONS = exports.PLAYBACKRATES_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "playbackRates": [0.25, 0.5, 1, 1.5, 2],
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": { "hls": { "withCredentials": false } },
            "html5": { "hls": { "withCredentials": false } },
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg"
        }
    }
};

var BACKGROUND_OPTIONS = exports.BACKGROUND_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "muted": true,
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": false,
            "flash": { "hls": { "withCredentials": false } },
            "html5": { "hls": { "withCredentials": false } },
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg"
        }
    }
};

var DOWNLOAD_OPTIONS = exports.DOWNLOAD_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "playbackRates": [0.25, 0.5, 1, 1.5, 2],
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": { "hls": { "withCredentials": false } },
            "html5": { "hls": { "withCredentials": false } },
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg"
        },
        "downloadOptions": {
            "link": "https://download.webtv-solution.com/NGRlNjhkYTc1/acme/2018-06-07T20:30/demo/empreinte-motion-vf-61a5gyue-43_94.mp4",
            "name": "Teasing_empreinte.com"
        }
    }
};

var CAPTION_OPTIONS = exports.CAPTION_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "playbackRates": [0.25, 0.5, 1, 1.5, 2],
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": { "hls": { "withCredentials": false } },
            "html5": { "hls": { "withCredentials": false } },
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [{
                "src": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/cc\/vtt\/fr\/94.vtt",
                "kind": "captions",
                "srclang": "fr",
                "label": "Fran\xE7ais",
                "default": true
            }],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg"
        }
    }
};

var INFO_OPTIONS = exports.INFO_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "playbackRates": [0.25, 0.5, 1, 1.5, 2],
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": { "hls": { "withCredentials": false } },
            "html5": { "hls": { "withCredentials": false } },
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg"
        },
        "infoOptions": {
            "title": "Teasing empreinte.com",
            "image": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/mini\/cf1755458d37033d81799d089971d4dd.jpg",
            "list_lag": [],
            "duree": "00:01:10",
            "date": "2018-04-23",
            "description": "",
            "contributeur": "empadmin",
            "nb_views": 68
        }
    }
};

var SETTING_OPTIONS = exports.SETTING_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "playbackRates": [0.25, 0.5, 1, 1.5, 2],
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": { "hls": { "withCredentials": false } },
            "html5": { "hls": { "withCredentials": false } },
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg"
        },
        "infoOptions": {
            "title": "Teasing empreinte.com",
            "image": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/mini\/cf1755458d37033d81799d089971d4dd.jpg",
            "list_lag": [],
            "duree": "00:01:10",
            "date": "2018-04-23",
            "description": "",
            "contributeur": "empadmin",
            "nb_views": 68
        }
    }
};

var SHARE_OPTIONS = exports.SHARE_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "playbackRates": [0.25, 0.5, 1, 1.5, 2],
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": { "hls": { "withCredentials": false } },
            "html5": { "hls": { "withCredentials": false } },
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg"
        },
        "shareOptions": {
            "socials": ["fb", "tw", "linkedin", "gp"],
            "title": "Teasing empreinte.com",
            "description": "",
            "image": "https:\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
            "fbAppId": "1980855782163905",
            "hashtag": "#Teasing_empreinte.com"
        }
    }
};

var EXPORT_OPTIONS = exports.EXPORT_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "playbackRates": [0.25, 0.5, 1, 1.5, 2],
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": { "hls": { "withCredentials": false } },
            "html5": { "hls": { "withCredentials": false } },
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg"
        }, "exportOptions": { "title": "Teasing empreinte.com", "url": "", "embedCode": "" }
    }
};

var TV_OPTIONS = exports.TV_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": false,
            "flash": { "hls": { "withCredentials": false } },
            "html5": { "hls": { "withCredentials": false } },
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg"
        }
    }
};

var COMMENTS_OPTIONS = exports.COMMENTS_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": { "hls": { "withCredentials": false } },
            "html5": { "hls": { "withCredentials": false } },
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg"
        }, "commentsOptions": true
    }
};

var QUESTION_AND_QUIZ_OPTIONS = exports.QUESTION_AND_QUIZ_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "videoId": 94,
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": { "hls": { "withCredentials": false } },
            "html5": { "hls": { "withCredentials": false } },
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg"
        }, "surveyOptions": true
    }
};

var SEARCH_OPTIONS = exports.SEARCH_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": { "hls": { "withCredentials": false } },
            "html5": { "hls": { "withCredentials": false } },
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg"
        }, "searchOptions": false
    }
};

var NAVIGATION_OPTIONS = exports.NAVIGATION_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": { "hls": { "withCredentials": false } },
            "html5": { "hls": { "withCredentials": false } },
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg"
        }
    }
};

var MAIL_OPTIONS = exports.MAIL_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": { "hls": { "withCredentials": false } },
            "html5": { "hls": { "withCredentials": false } },
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg"
        },
        "shareOptions": {
            "socials": ["fb", "tw", "linkedin", "mail"],
            "title": "Teasing empreinte.com",
            "description": "",
            "image": "https:\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
            "fbAppId": "1980855782163905",
            "hashtag": "#Teasing_empreinte.com"
        }, "sendMailOptions": true
    }
};

var HOTKEY_OPTIONS = exports.HOTKEY_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": { "hls": { "withCredentials": false } },
            "html5": { "hls": { "withCredentials": false } },
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg"
        }, "hotKeyOptions": true
    }
};

var INTERACTIVITY_OPTIONS = exports.INTERACTIVITY_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": { "hls": { "withCredentials": false } },
            "html5": { "hls": { "withCredentials": false } },
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg"
        },
        "interactivityOptions": {
            "video": { "id": 94 },
            "data": {
                "interactivity": [{
                    "start": 1,
                    "number": 0,
                    "title": "chapitre 1 ",
                    "type": "chapter",
                    "theme": "element_off"
                }, {
                    "start": 3,
                    "number": 0,
                    "title": "chapitre 3 ",
                    "type": "chapter",
                    "theme": "element_off"
                }, {
                    "start": 5,
                    "title": "quiz 1 ",
                    "type": "quiz",
                    "choices": [{ "choice": "reponse 1" }],
                    "theme": "element_off"
                }],
                "slides": [{
                    "name": "img_5aec27de3dd38.jpg",
                    "start": 1,
                    "type": "image",
                    "number": 1,
                    "loop": false,
                    "content": {
                        "type": "image",
                        "src": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/slides\/95\/img_5aec27de3dd38.jpg",
                        "thumbnail": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/slides\/95\/img_5aec27de3dd38.jpg",
                        "theme": "element_off"
                    }
                }, {
                    "name": "img_5aec27de3dd38.jpg",
                    "start": 3,
                    "type": "image",
                    "number": 2,
                    "loop": false,
                    "content": {
                        "type": "image",
                        "src": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/slides\/95\/img_5aec27de3dd38.jpg",
                        "thumbnail": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/slides\/95\/img_5aec27de3dd38.jpg",
                        "theme": "element_off"
                    }
                }, {
                    "name": "img_5aec27de3dd38.jpg",
                    "start": 5,
                    "type": "image",
                    "number": 3,
                    "loop": false,
                    "content": {
                        "type": "image",
                        "src": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/slides\/95\/img_5aec27de3dd38.jpg",
                        "thumbnail": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/slides\/95\/img_5aec27de3dd38.jpg",
                        "theme": "element_off"
                    }
                }, {
                    "name": "img_5aec27de3dd38.jpg",
                    "start": 7,
                    "type": "image",
                    "number": 4,
                    "loop": false,
                    "content": {
                        "type": "image",
                        "src": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/slides\/95\/img_5aec27de3dd38.jpg",
                        "thumbnail": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/slides\/95\/img_5aec27de3dd38.jpg",
                        "theme": "element_off"
                    }
                }, {
                    "name": "img_5aec29bd393ea.jpg",
                    "start": 13,
                    "type": "image",
                    "number": 6,
                    "loop": false,
                    "content": {
                        "type": "image",
                        "src": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/slides\/95\/img_5aec29bd393ea.jpg",
                        "thumbnail": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/slides\/95\/img_5aec29bd393ea.jpg",
                        "theme": "element_off"
                    }
                }]
            }
        }
    }
};

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(161),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(133)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(157),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(134)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(158),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(17);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(169);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _AddCustomer = __webpack_require__(146);

var _AddCustomer2 = _interopRequireDefault(_AddCustomer);

var _ListDemo = __webpack_require__(151);

var _ListDemo2 = _interopRequireDefault(_ListDemo);

var _DemoItem = __webpack_require__(148);

var _DemoItem2 = _interopRequireDefault(_DemoItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  routes: [{
    path: "/all",
    name: "all",
    component: _ListDemo2.default
  }, {
    path: "/",
    name: "all",
    redirect: "/all"
  }, {
    path: "/video",
    name: "Video",
    component: _ListDemo2.default
  }, {
    path: "/rm",
    name: "RM",
    component: _ListDemo2.default
  }, {
    path: "/simple",
    name: "simple",
    component: _DemoItem2.default,
    props: {
      type: "CAPTION_OPTIONS",
      componentName: "caption",
      title: "Sous-titres"
    }
  }, {
    path: "/navigation",
    name: "navigation",
    component: _DemoItem2.default,
    props: {
      type: "NAVIGATION_OPTIONS",
      componentName: "comments",
      title: "Navigation"
    }
  }, {
    path: "/interactivity",
    name: "interactivity",
    component: _DemoItem2.default,
    props: {
      type: "INTERACTIVITY_OPTIONS",
      componentName: "comments",
      title: "Interactivity"
    }
  }]
});

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(93);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _vue = __webpack_require__(17);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(51);

var _vuex2 = _interopRequireDefault(_vuex);

var _mutationTypes = __webpack_require__(89);

var types = _interopRequireWildcard(_mutationTypes);

var _customer = __webpack_require__(87);

var _customer2 = _interopRequireDefault(_customer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
  state: {
    itemsPerPage: 20,
    customers: []
  },

  getters: {
    allCustomers: function allCustomers(state) {
      return state.customers;
    }
  },

  actions: {
    getCustomers: function getCustomers(_ref) {
      var commit = _ref.commit;

      _customer2.default.all(function (customers) {
        commit(types.FETCH_CUSTOMERS, { customers: customers });
      });
    },
    addCustomer: function addCustomer(_ref2, customer) {
      var commit = _ref2.commit;

      _customer2.default.create(customer, function (customer) {
        commit(types.CREATE_CUSTOMER, { customer: customer });
      });
    }
  },

  mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.FETCH_CUSTOMERS, function (state, _ref3) {
    var customers = _ref3.customers;

    if (state.customers.length === 0) {
      state.customers = customers;
    }
  }), (0, _defineProperty3.default)(_mutations, types.CREATE_CUSTOMER, function (state, _ref4) {
    var customer = _ref4.customer;

    state.customers.push(customer);
  }), _mutations)
});

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(135)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(159),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = PlayerCdn;

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Header = __webpack_require__(150);

var _Header2 = _interopRequireDefault(_Header);

var _Footer = __webpack_require__(149);

var _Footer2 = _interopRequireDefault(_Footer);

var _Banner = __webpack_require__(48);

var _Banner2 = _interopRequireDefault(_Banner);

var _Highlights = __webpack_require__(27);

var _Highlights2 = _interopRequireDefault(_Highlights);

var _Menu = __webpack_require__(50);

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'app',
  components: { HeaderFo: _Header2.default, FooterFo: _Footer2.default, MenuEmp: _Menu2.default, Banner: _Banner2.default, Highlight: _Highlights2.default }
};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuex = __webpack_require__(51);

exports.default = {
  name: 'AddCustomer',
  data: function data() {
    return {
      customer: {}
    };
  },

  methods: (0, _vuex.mapActions)(['addCustomer'])
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'banner' };

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'banner-back',
  props: {
    title: {
      type: String,
      default: 'Vue!'
    }
  }
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loop = __webpack_require__(33);

var types = _interopRequireWildcard(_loop);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  props: {
    type: {
      type: String,
      default: "Vue!"
    },
    plugin: {
      type: String,
      default: "simple"
    }
  },
  data: function data() {
    return {
      loaded: false,
      query: { plugin: "simple", skin: "15" },
      standalone: {}
    };
  },

  computed: {
    getSourceIframe: function getSourceIframe() {
      switch (this.type) {
        case "CAPTION_OPTIONS":
          return "https://app.empreinte.tv/embed/empreinte-motion-3jggmqze-67_340_150054cMp";
        case "INTERACTIVITY_OPTIONS":
          return "https://app.empreinte.tv/embed/frenchpolynesiamattdevir-l8bsb9dj-12qkiC7?plugin=interactivity&skin=dark";

        case "NAVIGATION_OPTIONS":
          return "https://app.empreinte.tv/embed/BigBuckBunnyNXGJH";

        default:
          return "";
      }
    }
  },
  methods: {
    readyPlayer: function readyPlayer(param) {
      var player = param;
      player.cryptedParam = this.crypttext;
      this.loaded = true;
    }
  },
  created: function created() {
    this.query.plugin = this.plugin;
    this.standalone = types[this.type];
  }
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BannerBack = __webpack_require__(147);

var _BannerBack2 = _interopRequireDefault(_BannerBack);

var _Highlights = __webpack_require__(27);

var _Highlights2 = _interopRequireDefault(_Highlights);

var _Demo = __webpack_require__(49);

var _Demo2 = _interopRequireDefault(_Demo);

var _Loop = __webpack_require__(153);

var _Loop2 = _interopRequireDefault(_Loop);

var _Chromless = __webpack_require__(152);

var _Chromless2 = _interopRequireDefault(_Chromless);

var _PlayBackRates = __webpack_require__(154);

var _PlayBackRates2 = _interopRequireDefault(_PlayBackRates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'list-demo',
  props: {
    type: {
      type: String,
      default: 'Vue!'
    },
    plugin: {
      type: String,
      default: 'simple'
    },
    title: {
      type: String,
      default: 'Vue!'
    },
    componentName: {
      type: String,
      default: 'loop'
    },
    cdn: {
      type: Boolean,
      default: true
    }
  },
  components: { Demo: _Demo2.default, BannerBack: _BannerBack2.default, Loop: _Loop2.default, Chromless: _Chromless2.default, PlayBackRates: _PlayBackRates2.default }
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'footer-fo' };

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "header-fo"
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(94);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(92);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _Demo = __webpack_require__(49);

var _Demo2 = _interopRequireDefault(_Demo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "highlight",
  data: function data() {
    return {
      menu: __webpack_require__.i({"all":__webpack_require__.i({"path":"all","name":"TOUTES LES DÉMOS","item":__webpack_require__.i({"caption":__webpack_require__.i({"icon":"icon-uep-subs","path":"simple","name":"Sous-titres"}),"navigation":__webpack_require__.i({"icon":"icon-uep-default","path":"navigation","name":"navigation"}),"interactivity":__webpack_require__.i({"icon":"icon-uep-default","path":"interactivity","name":"interactivity"})})}),"Video":__webpack_require__.i({"path":"video","name":"Vidéos","item":__webpack_require__.i({"caption":__webpack_require__.i({"icon":"icon-uep-subs","path":"simple","name":"Sous-titres"})})}),"RM":__webpack_require__.i({"path":"rm","name":"Rich Media","item":__webpack_require__.i({"navigation":__webpack_require__.i({"icon":"icon-uep-default","path":"navigation","name":"navigation"}),"interactivity":__webpack_require__.i({"icon":"icon-uep-default","path":"interactivity","name":"interactivity"})})})}),
      items: [],
      type: "Sous-titres",
      showModal: false,
      itemToHandle: null,
      iframeSource: "",
      copied: false
    };
  },

  components: { Demo: _Demo2.default },

  methods: {
    getListDemo: function getListDemo() {
      this.items = this.menu[this.$route.name].item;
    },
    getCodeEmbed: function getCodeEmbed(s) {
      return "<iframe src=\"" + s + "\" width=\"100%\" height=\"100%\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen=\"allowfullscreen\" webkitallowfullscreen=\"true\" mozallowfullscreen=\"true\" frameborder=\"0\"></iframe>";
    },
    changeType: function changeType(t) {
      this.type = t;
    },
    showIntegrateModal: function showIntegrateModal(t) {
      this.copied = false;

      switch (t.name) {
        case "Sous-titres":
          this.iframeSource = "https://app.empreinte.tv/embed/empreinte-motion-3jggmqze-67_340_150054cMp";
          break;
        case "navigation":
          this.iframeSource = "https://app.empreinte.tv/embed/BigBuckBunnyNXGJH";
          break;

        case "interactivity":
          this.iframeSource = "https://app.empreinte.tv/embed/frenchpolynesiamattdevir-l8bsb9dj-12qkiC7?plugin=interactivity&skin=dark";
          break;

        default:
          this.iframeSource = "";
      }
      this.itemToHandle = t;
      this.showModal = true;
    },
    closeIntegrateModal: function closeIntegrateModal() {
      this.copied = false;
      this.itemToHandle = null;

      this.showModal = false;
    },
    copyToClipboard: function copyToClipboard() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.copied = true;
                _context.next = 4;
                return navigator.clipboard.writeText("<iframe src=\"" + _this.iframeSource + "\" width=\"100%\" height=\"100%\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen=\"allowfullscreen\" webkitallowfullscreen=\"true\" mozallowfullscreen=\"true\" frameborder=\"0\"></iframe>");

              case 4:
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                console.error("Failed to copy text: ", _context.t0);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 6]]);
      }))();
    },
    describeItem: function describeItem(n) {
      switch (n) {
        case "Sous-titres":
          return "Vidéo simple avec sous-titres";
        case "navigation":
          return "Vidéo enrichie avec indexation de média et chapitres ";
        case "interactivity":
          return "Vidéo interactive avec zone cachée cliquable, quiz, question, commentaires";
        default:
          return "";
      }
    }
  },
  created: function created() {
    this.items = this.menu[this.$route.name].item;
    eventHub.$on("getListDemo", this.getListDemo);
  },

  computed: {
    getType: function getType() {
      switch (this.type) {
        case "Sous-titres":
          this.iframeSource = "https://app.empreinte.tv/embed/empreinte-motion-3jggmqze-67_340_150054cMp";
          return "CAPTION_OPTIONS";
        case "navigation":
          this.iframeSource = "https://app.empreinte.tv/embed/BigBuckBunnyNXGJH";

          return "NAVIGATION_OPTIONS";
        case "interactivity":
          this.iframeSource = "https://app.empreinte.tv/embed/frenchpolynesiamattdevir-l8bsb9dj-12qkiC7?plugin=interactivity&skin=dark";

          return "INTERACTIVITY_OPTIONS";
        default:
          return "CAPTION_OPTIONS";
      }
    }
  }
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Banner = __webpack_require__(48);

var _Banner2 = _interopRequireDefault(_Banner);

var _Highlights = __webpack_require__(27);

var _Highlights2 = _interopRequireDefault(_Highlights);

var _Menu = __webpack_require__(50);

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'list-demo',
  components: { MenuEmp: _Menu2.default, Banner: _Banner2.default, Highlight: _Highlights2.default }
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'menu-emp',
  data: function data() {
    return {
      menu: __webpack_require__.i({"all":__webpack_require__.i({"path":"all","name":"TOUTES LES DÉMOS","item":__webpack_require__.i({"caption":__webpack_require__.i({"icon":"icon-uep-subs","path":"simple","name":"Sous-titres"}),"navigation":__webpack_require__.i({"icon":"icon-uep-default","path":"navigation","name":"navigation"}),"interactivity":__webpack_require__.i({"icon":"icon-uep-default","path":"interactivity","name":"interactivity"})})}),"Video":__webpack_require__.i({"path":"video","name":"Vidéos","item":__webpack_require__.i({"caption":__webpack_require__.i({"icon":"icon-uep-subs","path":"simple","name":"Sous-titres"})})}),"RM":__webpack_require__.i({"path":"rm","name":"Rich Media","item":__webpack_require__.i({"navigation":__webpack_require__.i({"icon":"icon-uep-default","path":"navigation","name":"navigation"}),"interactivity":__webpack_require__.i({"icon":"icon-uep-default","path":"interactivity","name":"interactivity"})})})})
    };
  },

  methods: {
    clickMenu: function clickMenu(event, index) {
      eventHub.$emit('getListDemo');
    }
  } };

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'menu-emp',
  data: function data() {
    return {
      menu: __webpack_require__.i({"all":__webpack_require__.i({"path":"all","name":"TOUTES LES DÉMOS","item":__webpack_require__.i({"caption":__webpack_require__.i({"icon":"icon-uep-subs","path":"simple","name":"Sous-titres"}),"navigation":__webpack_require__.i({"icon":"icon-uep-default","path":"navigation","name":"navigation"}),"interactivity":__webpack_require__.i({"icon":"icon-uep-default","path":"interactivity","name":"interactivity"})})}),"Video":__webpack_require__.i({"path":"video","name":"Vidéos","item":__webpack_require__.i({"caption":__webpack_require__.i({"icon":"icon-uep-subs","path":"simple","name":"Sous-titres"})})}),"RM":__webpack_require__.i({"path":"rm","name":"Rich Media","item":__webpack_require__.i({"navigation":__webpack_require__.i({"icon":"icon-uep-default","path":"navigation","name":"navigation"}),"interactivity":__webpack_require__.i({"icon":"icon-uep-default","path":"interactivity","name":"interactivity"})})})})
    };
  }
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loop = __webpack_require__(33);

exports.default = {
  data: function data() {
    return {
      loaded: false,
      query: { plugin: "simple", skin: "15" },
      standalone: _loop.LOOP_OPTIONS
    };
  },

  methods: {
    readyPlayer: function readyPlayer(param) {
      var player = param;
      player.cryptedParam = this.crypttext;
      this.loaded = true;
    }
  }
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'menu-emp',
  data: function data() {
    return {
      menu: __webpack_require__.i({"all":__webpack_require__.i({"path":"all","name":"TOUTES LES DÉMOS","item":__webpack_require__.i({"caption":__webpack_require__.i({"icon":"icon-uep-subs","path":"simple","name":"Sous-titres"}),"navigation":__webpack_require__.i({"icon":"icon-uep-default","path":"navigation","name":"navigation"}),"interactivity":__webpack_require__.i({"icon":"icon-uep-default","path":"interactivity","name":"interactivity"})})}),"Video":__webpack_require__.i({"path":"video","name":"Vidéos","item":__webpack_require__.i({"caption":__webpack_require__.i({"icon":"icon-uep-subs","path":"simple","name":"Sous-titres"})})}),"RM":__webpack_require__.i({"path":"rm","name":"Rich Media","item":__webpack_require__.i({"navigation":__webpack_require__.i({"icon":"icon-uep-default","path":"navigation","name":"navigation"}),"interactivity":__webpack_require__.i({"icon":"icon-uep-default","path":"interactivity","name":"interactivity"})})})})
    };
  }
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(56);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  all: function all(callback) {
    _axios2.default.get('https://jsonplaceholder.typicode.com/users').then(function (response) {
      callback(response.data);
    }).catch(function (err) {
      console.log(err);
    });
  },
  create: function create(customer, callback) {
    _axios2.default.post('https://jsonplaceholder.typicode.com/users', {
      email: customer.email,
      username: customer.username,
      name: customer.name
    }).then(function (response) {
      callback(response.data);
    }).catch(function (err) {
      console.log(err);
    });
  }
};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(17);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(54);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(52);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(53);

var _store2 = _interopRequireDefault(_store);

var _playerCdn = __webpack_require__(55);

var _playerCdn2 = _interopRequireDefault(_playerCdn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;

_vue2.default.use(_playerCdn2.default);
window.eventHub = new _vue2.default();

new _vue2.default({
  el: '#app',
  router: _router2.default,
  store: _store2.default,
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FETCH_CUSTOMERS = exports.FETCH_CUSTOMERS = 'FETCH_CUSTOMERS';
var CREATE_CUSTOMER = exports.CREATE_CUSTOMER = 'CREATE_CUSTOMER';

/***/ }),
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(167),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(162),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(137)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(163),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(156),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(132)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(155),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(168),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(136)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(160),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(140)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(166),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(139)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(165),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticClass: "link",
    attrs: {
      "target": "_blank",
      "rel": "noreferrer",
      "href": "https://www.empreinte.com/"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/logo-emp.png",
      "alt": "empreinte_logo"
    }
  })])])])])
}]}

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('footer', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_vm._v("\n        ©\n        "), _c('a', {
    attrs: {
      "href": "//www.empreinte.com/",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(new Date().getFullYear()) + " Empreinte.com")])])])])])
},staticRenderFns: []}

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo_loop"
  }, [_c('div', {
    staticClass: "player_centre"
  }, [_c('div', {
    staticClass: "player_responsive"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.getSourceIframe,
      "width": "100%",
      "height": "100%",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": "allowfullscreen",
      "webkitallowfullscreen": "true",
      "mozallowfullscreen": "true",
      "frameborder": "0"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "menu_emp"
    }
  }, [_c('ul', _vm._l((_vm.menu), function(link, index) {
    return _c('router-link', {
      ref: link.name,
      refInFor: true,
      attrs: {
        "to": link.path,
        "tag": "li"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.clickMenu($event, index)
        }
      }
    }, [_c('a', [_vm._v("\n        " + _vm._s(link.name) + "\n        ")])])
  }), 1)])
},staticRenderFns: []}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header-fo'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('footer-fo')], 1)
},staticRenderFns: []}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "menu_emp"
    }
  }, [_c('ul', _vm._l((_vm.menu), function(link, index) {
    return _c('router-link', {
      ref: link.name,
      refInFor: true,
      attrs: {
        "to": link.path,
        "tag": "li"
      }
    }, [_c('a', [_vm._v("\n        " + _vm._s(link.name) + "\n        ")])])
  }), 1)])
},staticRenderFns: []}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('section', {
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("Découvrez toutes les fonctionnalités")]), _vm._v(" "), _c('h1', [_vm._v("PLAYER DEMO")])])])])
}]}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner_back"
  }, [_c('section', {
    attrs: {
      "id": "banner_back"
    }
  }, [_c('div', {
    staticClass: "inner_back"
  }, [_c('p', [_vm._v(_vm._s(_vm.title))])])])])
},staticRenderFns: []}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "list_demo"
    }
  }, [_c('banner-back', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "icon-uep icon-uep-back button",
    attrs: {
      "to": "/",
      "tag": "button"
    }
  }, [_vm._v("\n    Retour\n  ")]), _vm._v(" "), _c('keep-alive', [_c('demo', {
    staticClass: "md-transparent",
    attrs: {
      "type": _vm.type,
      "plugin": _vm.plugin
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('section', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Player vidéo universel EMPREINTE.COM")]), _vm._v(" "), _c('demo', {
    staticClass: "md-transparent",
    attrs: {
      "type": _vm.getType
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "highlights"
  }, _vm._l((_vm.items), function(item) {
    return _c('section', [_c('div', {
      staticClass: "content",
      class: {
        'selected-card': _vm.type === item.name
      }
    }, [_c('header', [_c('div', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(_vm.describeItem(item.name)))])]), _vm._v(" "), _c('div', {
      staticClass: "item-btns"
    }, [_c('button', {
      ref: item.name,
      refInFor: true,
      staticClass: "button button-small button-sec",
      on: {
        "click": function($event) {
          return _vm.showIntegrateModal(item)
        }
      }
    }, [_vm._v("\n                Intégrer\n              ")]), _vm._v(" "), _c('button', {
      ref: item.name,
      refInFor: true,
      staticClass: "button button-small",
      on: {
        "click": function($event) {
          return _vm.changeType(item.name)
        }
      }
    }, [_vm._v("\n                Visualiser\n              ")])])])])
  }), 0)])], 1), _vm._v(" "), (_vm.showModal && _vm.itemToHandle) ? _c('div', {
    staticClass: "integrate-modal"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "btnClose",
    on: {
      "click": function($event) {
        return _vm.closeIntegrateModal()
      }
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "embed-container"
  }, [_c('div', {
    staticClass: "embed-title"
  }, [_vm._v("Code Embed")]), _vm._v(" "), _c('div', {
    staticClass: "embed-code"
  }, [_c('textarea', {
    attrs: {
      "rows": "6",
      "id": "text-to-copy"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.getCodeEmbed(this.iframeSource))
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button button-small",
    class: {
      'button-sec': _vm.copied
    },
    on: {
      "click": function($event) {
        return _vm.copyToClipboard()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.copied ? "Copié" : "Copier") + "\n            ")])])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "menu_emp"
    }
  }, [_c('ul', _vm._l((_vm.menu), function(link, index) {
    return _c('router-link', {
      ref: link.name,
      refInFor: true,
      attrs: {
        "to": link.path,
        "tag": "li"
      }
    }, [_c('a', [_vm._v("\n        " + _vm._s(link.name) + "\n        ")])])
  }), 1)])
},staticRenderFns: []}

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo_loop"
  }, [_c('div', {
    staticClass: "player_centre"
  }, [_c('div', {
    staticClass: "player_responsive"
  }, [_c('uep-player', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loaded),
      expression: "loaded"
    }],
    staticClass: "player",
    attrs: {
      "standalone": _vm.standalone,
      "query": _vm.query
    },
    on: {
      "readyPlayer": _vm.readyPlayer
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4 col-md-4 col-md-offset-4 col-sm-offset-4",
    attrs: {
      "id": "customer"
    }
  }, [_c('h2', {
    staticClass: "sub-header"
  }, [_vm._v("Add Customer")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.email),
      expression: "customer.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.customer.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Username")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.username),
      expression: "customer.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Username"
    },
    domProps: {
      "value": (_vm.customer.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.name),
      expression: "customer.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.customer.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.addCustomer(_vm.customer)
      }
    }
  }, [_vm._v("Submit")])])
},staticRenderFns: []}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "list_demo"
    }
  }, [_c('highlight')], 1)
},staticRenderFns: []}

/***/ })
]),[88]);


// WEBPACK FOOTER //
// static/js/app.0fa4acc0a9bbc3506a9a.js